export default __webpack_public_path__ + "static/media/social-facebook.66e00054.svg";